import React from 'react';
import PropTypes from 'prop-types';
import { useIsMobile } from 'utils/hooks';
import { Dialog, Div } from 'components/Ui';
import { ThumbUpGreen } from 'images';
import styles from './styles.scss';

const PasswordResetEmailSentDialog = ({ open, email, onClose }) => {
  const isMobile = useIsMobile();
  return (
    <Dialog
      size="large"
      fullScreen={isMobile}
      isAutoClose={false}
      isCloseIcon
      open={open}
      overflowContent
      onClose={onClose}
    >
      <div className={styles.container}>
        <div
          className={!isMobile ? styles.subContainer : styles.mobileContainer}
        >
          <div className={styles.imageContainer}>
            <img src={ThumbUpGreen} alt=""></img>
          </div>
          <Div className={styles.textContainer}>
            A password reset email has been sent to:
          </Div>
          <div className={styles.emailContainer}>{email}</div>
        </div>
      </div>
    </Dialog>
  );
};

PasswordResetEmailSentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PasswordResetEmailSentDialog;
